const CloseFill = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#2C2C2C"
        fillRule="evenodd"
        d="M13.536 12.65a.626.626 0 1 1-.884.887l-2.648-2.65-2.667 2.67a.634.634 0 0 1-.89 0 .634.634 0 0 1 0-.895l2.666-2.668L6.465 7.35a.625.625 0 1 1 .884-.888l2.647 2.65 2.686-2.687a.634.634 0 0 1 .891 0 .634.634 0 0 1 0 .894l-2.686 2.687 2.649 2.644ZM10 0C4.477 0 0 4.475 0 10s4.477 10 10 10 10-4.475 10-10S15.523 0 10 0Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default CloseFill;
